import React from 'react';

export default function Link (props) {
  return (
      <a href={props.data.url} rel="noopener noreferrer" target='_blank'>
        { props.data.image ?
          (<img src={props.data.image} alt=''/>) :
          props.data.name
        }
      </a>
  )
}